import { Autocomplete, Box, TextField, createFilterOptions } from "@mui/material";
import { SyntheticEvent } from "react";
import { i18n } from "../../../translate/i18n";

interface IOption {
  label: string;
  id: string | number;
}

interface IData {
  key: string;
  options: IOption[];
  disabled?: boolean;
  title: string;
  onChange: (
    event: SyntheticEvent<Element, Event>,
    value: IOption | null
  ) => void;
  value?: IOption | null;
}

const filter = createFilterOptions<IOption>();

const AutoComplete = ({
  options,
  disabled = false,
  title,
  onChange,
  key,
  value,
}: IData) => {
  return (
    <Autocomplete
      id={key}
      key={key}
      fullWidth
      freeSolo
      options={options}
      disabled={disabled}
      autoHighlight
      getOptionLabel={(option: IOption | string) =>
        typeof option === "string" ? option : option.label
      }
      filterOptions={(opts, params) => {
        const filtered = filter(opts, params);
        const { inputValue } = params;

        // Verifica se já existe opção com esse texto
        const isExisting = opts.some((o) => o.label === inputValue);

        if (inputValue !== "" && !isExisting) {
          filtered.push({
            label: `${i18n.t("buttons.add")} "${inputValue}"`,
            id: inputValue,
          });
        }

        return filtered;
      }}
      onChange={(event, value) => {
        if (typeof value === "string") {
          // caso clique direto no enter
          onChange(event, { label: value, id: value });
        } else if (value && value.label.startsWith(`${i18n.t("buttons.add")} "`)) {
          // caso clique em "Adicionar ..."
          const newValue = value.id.toString();
          onChange(event, { label: newValue, id: newValue });
        } else {
          onChange(event, value as IOption | null);
        }
      }}
      value={value ?? null}
      renderOption={(props: any, option: IOption) => {
        const { key, ...optionProps } = props;
        return (
          <Box key={key} component="li" {...optionProps}>
            {option.label}
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={title}
          inputProps={{
            ...params.inputProps,
          }}
        />
      )}
    />
  );
};

export default AutoComplete;
